//import LocalStorage from 'localStorage'
import Hosts from '../../../Hosts';


const object_type = 'formation/course'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
//const api_list_route = `${Hosts.SIMCore_API}/cpf`
const api_list_route = companycode => `${Hosts.SIMCore_API}/${object_type}/${companycode}`


const base_endpoint = '/formation_module'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
    gest: `${base_endpoint}_gest`,
    evaluation: `${base_endpoint}_evaluation`
}

const data_interface = {
    id: '',
    info: {
        companycode: '', 
        name: '',
        date: {
            creation: '',
            begin: '',
            end: '',
            publication: '',
            extension: '',
            modified: []
        }, 
        language: [], 
        
        media: {
            id: '',
            link: '',
        },  
        seo: {
            title: '',
            description: '',
            keywords: '',
            language: []
        }, 
        type: 'course',
        parent: '0', 
        order: '1',
        slug: '', 
        trainers: [],
        status: 'without_emphasis',
    },
    content: [
        {
            title: '',
            abstract: '',
            text: '',
            duration: '',
            formation_lang: 'formation_language_pt',
            modules: [],
            sessions: '',
            schedule: '',
            start_date: '',
            end_date: '',
            target: '',
            vacancies: '',
            media: {
                image: [],
                doc: []
            },
            language: []
        }
    ]
}

export {
    object_type,
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
